import { useEffect, useMemo } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { PqrNotificationClient } from '../../../../../../shared/types/modules/pqr';
import { PqrNotificationClientProps } from './props';
import {
    asyncGetAccount,
    asyncGetAccountByDocument,
} from '../../../../../../services/accounts.service';
import { Account } from '../../../../../../shared/types/modules/account';

export const usePqrNotificationClient = ({
    data,
    onChangeData,
    onChangeFormik,
    idAccount,
}: PqrNotificationClientProps) => {
    const queryParams = useMemo(
        () => new URLSearchParams(location.search),
        [location.search]
    );
    const document = queryParams.get('document')?.trim();
    const isUsingDocument = idAccount === 'bp' && document; // differenciates if request comes from Brigth Pattern

    const onSubmit = (data: PqrNotificationClient) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('email', data?.email || formik.values.email);
        formik?.setFieldValue('phone', data?.phone || formik.values.phone);
    }, [data]);

    useEffect(() => {
        const fetchAccount = async () => {
            let account: Account | undefined;

            if (Boolean(idAccount?.trim()) && idAccount !== 'bp') {
                account = await asyncGetAccount(idAccount || '');
            } else if (isUsingDocument) {
                account = await asyncGetAccountByDocument(document);
            }
            if (account) {
                formik?.setFieldValue('email', account?.email || '');
                formik?.setFieldValue('phone', account?.cellPhone || '');
            }
        };

        fetchAccount();
    }, [idAccount, document]);

    return {
        formik,
    };
};
